<template>
  <div class="header content">
    <div class="columns is-vcentered is-mobile">
      <div class="column is-narrow">
        <div class="logo" :style="`background-image:url(${logoAvailable})`"></div>
      </div>
      <div class="column is-hidden-small">
        <h3 class="is-marginless has-text-weight-bold">{{ clientTitle }}</h3>
        <span class="has-text-weight-bold is-size-7">Image Capture Tool</span>
      </div>
      <div class="column has-text-right">
        <div class="dropdown is-right is-hoverable">
          <div class="dropdown-trigger">
            <a class="button is-text" aria-haspopup="true" aria-controls="dropdown-menu4">
              <span class="is-margin-right">
                <img :src="`/img/flags/${lang.toUpperCase()}.png`"/>
              </span>
              <span>{{ $root.langsAvailable[lang] }}</span>
              <span class="icon is-small">
                <svg-icon icon="chevron-down" :label="$root.term('switch_language')"/>
              </span>
            </a>
          </div>
          <div class="dropdown-menu" id="dropdown-menu4" role="menu">
            <div class="dropdown-content has-text-left">
              <div v-for="(item, index) in langsAvailable" class="dropdown-item" :key="index">
                <a @click="setLanguage(item)" class="button is-text">
                  <span class="is-margin-right">
                    <img :src="`/img/flags/${item.toUpperCase()}.png`"/>
                  </span>
                  <span>{{ $root.langsAvailable[item] }}</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import SvgIcon from '@/components/SvgIcon'
export default {
  name: 'HeaderBar',
  components: {
    SvgIcon
  },
  props: {
    hasRightVisible: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    clientTitle () {
      return this.mycase.client && this.mycase.client.title ? this.mycase.client.title : this.clientNameDefault
    },
    logoAvailable () {
      return this.mycase.client && this.mycase.client.logo_url ? this.mycase.client.logo_url : this.logoDefault
    },
    langsAvailable () {
      return Object.keys(this.$root.langsAvailable).filter(e => e !== this.lang)
    },
    ...mapState([
      'mycase',
      'lang'
    ])
  },
  data () {
    return {
      clientNameDefault: 'Logo',
      logoDefault: '/img/logo.jpg'
    }
  },
  methods: {
    setLanguage (lang) {
      this.$store.dispatch('showLoader', { message: 'Please wait...' })
      this.$store.dispatch('lang', { lang: lang }).then(res => {
        this.$store.dispatch('hideLoader')
        console.log(`✔️ language`)
      }).catch(err => {
        this.$store.dispatch('hideLoader')
        console.log(`❌ language: ${err}`)
      })
    },
    scrollToBottom () {
      document.querySelector('.menu-items').style.display = 'none'
      this.scrollTo(document.querySelector('body').clientHeight)
    },
    toggleNavBar () {
      let menu = document.querySelector('.menu-items')
      if (menu.style.display === '') {
        menu.style.display = 'none'
      }
      menu.style.display = menu.style.display !== 'none' ? 'none' : 'block'
    }
  }
}
</script>
